import { combineReducers } from "redux";
import { AceAuth } from "./AceAuth";
import { message, apiLoading, pageLoading } from "./message";
import { subscriptionPlan } from "./Subsription";
import { customerData } from "./Customer";
import { localeMetrics } from "./locale";

export default combineReducers({
	AceAuth,
	message,
	apiLoading,
	pageLoading,
	subscriptionPlan,
	customerData,
	localeMetrics,
});
